import React, { useState, useEffect } from "react";
import TableHelper from "../TableHelper";
import "./ErrorNavigation.scss";

export default ({ errorNavigation, hierarchyLevel }) => {
	const [currentError, setCurrentError] = useState(0);

	function targetError(targetIndex) {
		setCurrentError(targetIndex);
		const errorLocation = errorNavigation[targetIndex];
		TableHelper.navigateToError(errorLocation, hierarchyLevel);
	}

	useEffect(() => {
		setCurrentError(0);
	}, [errorNavigation]);

	return (
		<div className="errorNavigationContainer" id={`${hierarchyLevel}_error_nav`}>
			<div className="errorNavigation">
				{errorNavigation.length} errors found
				<div className="navigation">
					<i
						className={`arrow left ${currentError == 0 ? "inactive" : "active"}`}
						{...(currentError != 0 && {
							onClick: () => {
								targetError(currentError - 1);
							}
						})}
					>
						&#x3c;
					</i>
					<p
						className="currentError"
						onClick={() => {
							targetError(currentError);
						}}
					>
						{currentError + 1} of {errorNavigation.length}
					</p>
					<i
						className={`arrow right ${currentError == errorNavigation.length - 1 ? "inactive" : "active"}`}
						{...(currentError != errorNavigation.length - 1 && {
							onClick: () => {
								targetError(currentError + 1);
							}
						})}
					>
						&#x3e;
					</i>
				</div>
			</div>
			<span className="error__msg">{errorNavigation[currentError]?.message}</span>
		</div>
	);
};
